import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import PhoneOtpLogin from "@/components/PhoneOtpLogin";
import { ArrowLeft, ShieldCheck } from "lucide-react";

const ParentLogin = () => {
  const nav = useNavigate();
  const onSuccess = ({ access_token }) => {
    localStorage.setItem("ca_parent_token", access_token);
    toast.success("Welcome back!");
    nav("/portal");
  };
  return (
    <main data-testid="parent-login-page" className="min-h-screen flex flex-col bg-background">
      <div className="p-6">
        <Link to="/" className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-primary">
          <ArrowLeft size={14} /> Home
        </Link>
      </div>
      <div className="flex-1 flex items-center justify-center px-6">
        <div className="w-full max-w-md rounded-2xl border border-border/70 bg-card p-8 md:p-10">
          <div className="flex items-center gap-3 mb-6">
            <div className="h-10 w-10 rounded-full bg-primary text-primary-foreground flex items-center justify-center">
              <ShieldCheck size={18} />
            </div>
            <div>
              <div className="text-xs tracking-[0.25em] uppercase text-primary/80">Parent portal</div>
              <div className="font-serif-display text-2xl">Sign in with your phone</div>
            </div>
          </div>
          <p className="text-sm text-muted-foreground mb-6">
            Enter the mobile number you used when booking. We'll text you a one-time code — no password to remember.
          </p>
          <PhoneOtpLogin purpose="parent" onSuccess={onSuccess} allowSignup />
        </div>
      </div>
    </main>
  );
};

export default ParentLogin;
